module.exports = __webpack_public_path__ + "static/media/linhas-onibus.20163793.png";